import React from 'react';
import T from 'prop-types';
import { mapValues, pickBy } from 'lodash-es';

import { SmartChart } from '../../../../../components/Chart';
import Skeleton from '../../../../../components/Skeleton';
import { columnChartConfig } from './config';
import { advancedPartialFilters } from '../../configs/chart-config';

const TsPenetrationIndexChart = ({ metricOption, series, isPending, isPress }) => {
  const metricSeries = pickBy(series, (_, key) => key === `${metricOption.value}_index`);

  const metaSeries = mapValues(metricSeries, () => ({
    name: `${metricOption.label} (index)`,
    color: '#348BE3',
    visible: true,
    type: 'spline',
  }));

  const chartConfig = columnChartConfig({
    series: metricSeries,
    type: 'spline',
    height: 277,
    unit: '',
    isPress,
  });

  return (
    <div className="ts-penetration-index-chart">
      {isPending ? (
        <Skeleton height={277} className="d-flex" />
      ) : (
        <SmartChart
          chartId="ts-penetration-index-chart"
          series={metricSeries}
          metaSeriesData={metaSeries}
          config={chartConfig}
          allowPartialPeriods
          filters={advancedPartialFilters}
        />
      )}
    </div>
  );
};

TsPenetrationIndexChart.propTypes = {
  metricOption: T.shape({
    value: T.string,
    label: T.string,
  }).isRequired,
  series: T.object,
  isPending: T.bool,
  isPress: T.bool,
};

export default TsPenetrationIndexChart;
